module.exports = __webpack_public_path__ + "media/images/icon-cart-white-dd541f551969581f2dcf27bd82df0927.svg";